import { Box, Button, TextField, useTheme } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { tokens } from "../../../theme";
import { mockDataTeam } from "../../../data/mockData";
import Header from "../../../components/Header";

const DetalhesColaborador = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  // Encontra o colaborador a ser exibido pelos detalhes
  const colaborador = mockDataTeam.find((colaborador) => colaborador.id === parseInt(id));

  return (
    <Box m="20px">
      <Header title="Detalhes do Colaborador" subtitle="Veja os detalhes do colaborador" />
      <Box
        component="form"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '20px',
          backgroundColor: colors.primary[400],
          padding: '20px',
          borderRadius: '8px'
        }}
      >
        <TextField
          label="Nome do Colaborador"
          name="name"
          value={colaborador.name}
          fullWidth
          variant="filled"
          disabled // Desabilita a edição do campo
        />
        <TextField
          label="Telefone"
          name="phone"
          value={colaborador.phone}
          fullWidth
          variant="filled"
          disabled // Desabilita a edição do campo
        />
        <TextField
          label="Email"
          name="email"
          value={colaborador.email}
          fullWidth
          variant="filled"
          disabled // Desabilita a edição do campo
        />
        <TextField
          label="Cargo"
          name="position"
          value={colaborador.position}
          fullWidth
          variant="filled"
          disabled // Desabilita a edição do campo
        />
        <Box display="flex" justifyContent="space-between">
          <Button variant="contained" color="primary" onClick={() => navigate(`/colaboradores/editar/${id}`)}>
            Editar
          </Button>
          <Button variant="contained" color="secondary" onClick={() => navigate("/colaboradores")}>
            Voltar
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default DetalhesColaborador;
